/**
 * UserContextProvider - Wraps app and fetches user context on mount
 */

import React from 'react';
import { useUserContext } from './UserContextProvider.hook';

interface UserContextProviderProps {
  children: React.ReactNode;
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
  useUserContext(); // Fetches and stores user context on mount
  return <>{children}</>;
};
